import { apiGateway } from "@/_old/services/api-gateway";
import { productTypeIds } from "@/core/utils";
import { GetRankingsParams, GetRankingsResponse } from "../types";

const getRankings = async (
  endpoint: "space" | "city" | "user" | "group",
  params: GetRankingsParams,
  signal?: AbortSignal,
): Promise<GetRankingsResponse> => {
  const searchParams = new URLSearchParams();

  searchParams.set("page", String(params.page));
  searchParams.set("limit", String(params.limit));
  searchParams.set("rank_by", params.rank_by);
  searchParams.set("start_date", `${params.startDate}`);
  searchParams.set("end_date", `${params.endDate}`);

  if (params.packageCycleId)
    searchParams.set("package_cycle_id", String(params.packageCycleId));
  if (params.search) searchParams.set("name", params.search);
  if (params.cities && params.cities.length > 0) {
    params.cities.forEach((city) => searchParams.append("cities[]", city.name));
  }
  if (params.group_id) searchParams.set("group_id", String(params.group_id));
  if (params.type && params.type.length > 0) {
    params.type.forEach((t) =>
      searchParams.append("types[]", String(productTypeIds[t])),
    );
  }
  if (params.status && params.status.length > 0) {
    params.status.forEach((s) => searchParams.append("status[]", String(s)));
  }
  if (params.users && params.users.length > 0) {
    const userIds = params.users.map((user) => user.user?.id).filter(Boolean);
    userIds.forEach((id) => searchParams.append("users[]", String(id)));
  }
  if (params.spaces && params.spaces.length > 0) {
    params.spaces.forEach((space) => searchParams.append("spaces[]", space.id));
  }

  const { data, total, page, limit, total_pages } = await apiGateway
    .get(`/ranking/by-${endpoint}`, {
      params: searchParams,
      signal,
    })
    .then((res) => {
      return {
        data: res.data.data,
        total: res.data.total,
        page: res.data.page,
        limit: res.data.limit,
        total_pages: res.data.total_pages,
      };
    });

  return {
    data,
    total,
    page,
    limit,
    total_pages,
  } as unknown as GetRankingsResponse;
};

export { getRankings };
